import React from "react";
import useWebsiteConfiguration from "../../../hooks/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfigurationType.enum";
import "../../../styles/components/home/aboutUs/homeAboutUsComponent.scss";

const HomeAboutUsComponent = () => {
  const { Title, Text } = useWebsiteConfiguration(websiteConfigurationEnum.HomeAboutUs);
  const { Url: backgroundImageUrl } = useWebsiteConfiguration(websiteConfigurationEnum.HomeAboutUsImage) || {};

  return (
    <div
      className="homeAboutUsContainer"
      style={{
        backgroundImage: `url(${backgroundImageUrl || ""})`, // Set background image dynamically
      }}
    >
      <div className="overlay"></div> {/* Dark overlay */}
      <div className="content">
        <h1>{Title}</h1>
        <p>{Text}</p>
      </div>
    </div>
  );
};

export default HomeAboutUsComponent;
